export default "__VITE_ASSET__Dmhj2foY__"